// MAIN COLORS DEFAULT
let colors = {
  primary : '#007bff',
  success : '#28C76F',
  danger  : '#EA5455',
  warning : '#FF9F43',
  dark    : '#1E1E1E',
}

// THEME CONFIG
export const themeConfig = {
  routerTransition  : "zoom-fade", 
  theme             : "light",    
}

// IRIS CONFIG
export const irisConfig = {
  customers      : "U1NLtVcEX66YrTYMbByx",
  sites          : "bgXAJgrbdUiYGuAehfQp",
  menuHeader     : "gZNiJueQmLZZLSoiUEvx",
  menuFooter     : "Ay6zv2gBGn47dTkrhkQ8",
  googleAnalyticsID : "UA-189705080-1"
} 

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors } })
